// Document Classifier Module - Clean & Modular
export async function classifyDocument(text) {
  if (!text || text.length < 50) {
    console.log('[CLASSIFIER] Text too short');
    return { document_type: "Unbekannt", confidence: 0, reason: "Text too short" };
  }

  const prompt = `You are an AI system that classifies business documents in a German real estate management system.
Return ONLY valid JSON.
Document types: Mietvertrag, Nachtrag, Übergabeprotokoll, Kontoauszug, Rechnung, Allgemein, Unbekannt
Rules: Be strict. If unsure, return "unknown". Include confidence (0-1).
Output format: {"document_type": "...", "confidence": 0.0-1.0, "reason": "..."}
Text: """${text.slice(0, 4000)}"""`;

  try {
    console.log('[CLASSIFIER] Calling LLM...');
    const response = await fetch('/api/ai/classify', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ prompt, temperature: 0, max_tokens: 500, timeout: 30000 })
    });

    if (!response.ok) throw new Error(`API error: ${response.status}`);
    const result = await response.json();
    const responseText = result.response || result.text || '';
    console.log('[CLASSIFIER] Response:', responseText.slice(0, 100));

    let parsed;
    try { parsed = JSON.parse(responseText); }
    catch (e) {
      console.error('[CLASSIFIER] Parse failed:', e);
      return { document_type: "Unbekannt", confidence: 0, reason: "Invalid JSON" };
    }

    if (!parsed?.document_type) {
      return { document_type: "Unbekannt", confidence: 0, reason: "Invalid response" };
    }

    const classification = {
      document_type: parsed.document_type || "unknown",
      confidence: typeof parsed.confidence === 'number' ? parsed.confidence : 0,
      reason: parsed.reason || ""
    };
    console.log('[CLASSIFIER] Result:', classification);
    return classification;
  } catch (error) {
    console.error('[CLASSIFIER] Error:', error);
    return { document_type: "Unbekannt", confidence: 0, reason: `Error: ${error.message}` };
  }
}

export function routeDocument(type, confidence) {
  if (confidence < 0.6) {
    console.log(`[ROUTING] Low confidence (${confidence}) → manual_review`);
    return "manual_review";
  }
  switch (type) {
    case "Mietvertrag": return "tenant_create";
    case "Nachtrag": return "tenant_update";
    case "Übergabeprotokoll": return "property_condition";
    case "Kontoauszug": return "payment_matching";
    case "Rechnung": return "expense_capture";
    default: return "manual_review";
  }
}
